export const LANGUAGE_CHOICES = ['en', 'hi'] as const;
export type LanguageChoice = (typeof LANGUAGE_CHOICES)[number];

export const LANGUAGE_NAMES: Readonly<Record<LanguageChoice, string>> = {
  en: 'English',
  hi: 'हिंदी',
};

export const LANGUAGE_SHORT: Readonly<Record<LanguageChoice, string>> = {
  en: 'EN',
  hi: 'हिं',
};

export const languageChoiceOf = (code: string | null | undefined): LanguageChoice =>
  code?.toLowerCase().startsWith('hi') ? 'hi' : 'en';
